import AxiosWrapper from '@/services/AxiosWrapper'

const END_POINT = '/publishers'

const get = () => AxiosWrapper.get(`${END_POINT}`)

export default {
  get
}
